import { Alert, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config.json'
import Link from '../common/util/input/Link'
import { DropAlert } from '../drops/DropAlert'
import { DropPaper } from '../drops/DropPaper'
import get from '../helpers/Api'
import Page from '../page/Page'
import { useSharedState } from '../waxplorer/Waxplorer'
import MainButton from '../common/util/input/MainButton'

const CreatorView = (props) => {
    const [state, , { login }] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const { t } = useTranslation('common')

    /** Contains the general info and custom links to editor and drop overview */
    const [collections, setCollections] = useState(null)
    const [isLoadingCollections, setIsLoadingCollections] = useState(true)

    const getCollections = async () => {
        get(
            `collections?authorized_account=${userName}&verified=all`,
            'wax-api',
        ).then(parseCollections)
    }
    const parseCollections = (res) => {
        if (res) {
            for (const collectionItem of res) {
                collectionItem.editorLink = `/creator/${collectionItem.collection}`
                collectionItem.dropLink = `/creator/${collectionItem.collection}/dropcreator`
                collectionItem.packLink = `/creator/${collectionItem.collection}/packcreator`
                collectionItem.craftsLink = `/creator/${collectionItem.collection}/craftcreator`
                collectionItem.redeemablesLink = `/creator/${collectionItem.collection}/redeemablecreator`
            }

            res.sort((a, b) => {
                if (a.name?.toLowerCase() <= b.name?.toLowerCase()) {
                    return -1
                } else return 1
            })
            // Add the "New Collection" CollectionItem to the beginning of the list
            res.unshift({
                name: t('editor.new_collection'),
                image: '/plus2.svg',
                editorLink: '/creator/new',
                dropLink: null,
            })
            setCollections(res)
        } else {
            setCollections([
                {
                    name: t('editor.new_collection'),
                    image: '/plus2.svg',
                    editorLink: '/creator/new',
                    dropLink: null,
                },
            ])
        }

        setIsLoadingCollections(false)
    }

    useEffect(() => {
        if (userName) {
            getCollections()
        }
    }, [userName])

    const CollectionCard = ({ collection }) => {
        return (
            <div className="m-2">
                <Link href={collection.editorLink}>
                    <div className="bg-white border-zinc-200 dark:!bg-paper border dark:!border-paperl rounded-md w-64 shadow-lg pb-3 h-full">
                        <div className="mb-10">
                            <img
                                className="object-cover w-full h-64 dark:!bg-black bg-zinc-100 rounded-t-md"
                                src={
                                    collection.name ===
                                    t('editor.new_collection')
                                        ? '/plus-square-outline.svg'
                                        : collection.image
                                        ? collection.image
                                        : config.ipfs +
                                          'QmVVE5aLtq4EtMe4Khev5CSic3AKqX2RuNTAB79thvpqQW'
                                }
                                alt={collection.name}
                            />
                        </div>

                        {collection.name === t('editor.new_collection') ? (
                            <div className="h-20">
                                <div className="relative my-auto -translate-y-1/2 top-1/2">
                                    <div className="mx-5">
                                        <MainButton
                                            //as="a"
                                            className="flex justify-center"
                                            href={collection.editorLink}
                                        >
                                            {' '}
                                            {t('editor.new_collection')}
                                        </MainButton>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="h-20">
                                <div className="mx-2 mb-1 overflow-y-auto text-xl text-center">
                                    {collection.name}
                                </div>
                                <div className="mb-3 text-sm text-center">
                                    {collection.templates} Template
                                    {collection.templates !== 1
                                        ? 's'
                                        : ''} - {collection.assets} Asset
                                    {collection.assets !== 1 ? 's' : ''}
                                </div>
                            </div>
                        )}
                    </div>
                </Link>
            </div>
        )
    }

    const OverviewContent = () => {
        return (
            <div className="mx-2 md:mx-5">
                <DropAlert
                    severity="info"
                    closable
                    title="Tutorial"
                    autoVerticalMargin={false}
                    className="flex justify-center mt-5"
                >
                    {t('editor.tutorial_on_how_to_use_our_editor')}
                    <Link
                        external
                        href="https://hivebp.medium.com/on-how-to-use-the-nfthive-io-c0a380f69497"
                    >
                        <p className="text-primary underline hover:dark:!text-neutral hover:text-black text-center">
                            {t('editor.you_can_read_it_here')}
                        </p>
                    </Link>
                </DropAlert>

                <DropPaper title={t('editor.select_or_create_collection')}>
                    {collections && collections.length <= 1 && (
                        <div className="mt-5">
                            <Alert severity="info">
                                Your NFTs must be grouped inside collections,
                                even single NFTs. To get a feeling for
                                collections, check out our{' '}
                                <Link
                                    className="text-primary"
                                    href={'/collections'}
                                >
                                    collection page
                                </Link>
                            </Alert>
                        </div>
                    )}
                    <div className="flex flex-wrap justify-center md:justify-start">
                        {collections
                            ?.sort((a, b) =>
                                b.templates === a.templates
                                    ? b.assets - a.assets
                                    : b.templates - a.templates,
                            )
                            .map((collection) => (
                                <CollectionCard
                                    collection={collection}
                                    key={
                                        'CollectionCard_' +
                                        collection.collectionName
                                    }
                                />
                            ))}
                    </div>
                </DropPaper>
                {/** <div className="flex justify-center">
         <DropAlert
         severity="warning"
         closable
         title="Whitelisting Requirements"
         className="my-5 max-w-132"
         autoVerticalMargin={false}
         >
         Please note that there are whitelisting requirements in
         order for your NFTs and collections to appear on
         nfthive.io:
         <span className="text-center underline cursor-pointer text-primary hover:dark:!text-neutral hover:text-black">
         <Link
         external={true}
         href="https://support.pink.gg/hc/en-us/articles/4763342411282-What-are-the-requirements-to-become-a-whitelisted-collection-on-AtomicHub-"
         >
         AtomicHub whitelisting requirements
         </Link>
         </span>
         </DropAlert>
         </div>**/}
            </div>
        )
    }

    useEffect(() => {
        const element = document.getElementById('EditCollectionPage')
        element.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    }, [userName])

    return (
        <Page
            id="EditCollectionPage"
            title={config.titles.editor}
            description={config.descriptions.editor}
            image={'https://www.nfthive.io/Drops-Creator-Packs.png'}
            banners={false}
            {...props}
            pageTitle={t('pages.create_your_nft_legacy')}
            pageSubtitle={t('pages.start_your_nft_collection')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Creator',
                    link: '/creator',
                },
            ]}
        >
            {userName ? (
                isLoadingCollections ? (
                    <div className="flex justify-center mt-10">
                        <CircularProgress />
                    </div>
                ) : (
                    <OverviewContent />
                )
            ) : (
                <div className="mt-5">
                    <div className="flex justify-center mt-5">
                        <Alert severity="warning">
                            {t('profile.must_be_logged_in')}
                            <div
                                className="cursor-pointer text-primary"
                                onClick={() => login()}
                            >
                                {t('profile.click_here_to_login')}
                            </div>
                        </Alert>
                    </div>
                    <div className="flex justify-center">
                        <div
                            className="w-full px-4 mt-4 cursor-pointer lg:w-1/2"
                            onClick={() => login()}
                        >
                            <img src="/Drops-Creator-Packs.png" />
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <div className="w-full px-4 mt-4 cursor-pointer lg:w-1/2">
                            {t('editor.description')}
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <div className="w-full px-4 mt-4 cursor-pointer lg:w-1/2">
                            {t('editor.sign_up_for_a_wallet_here')}:
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <div
                            className={
                                'w-full px-4 mt-4 cursor-pointer lg:w-1/2 '
                            }
                        >
                            <Link href={'https://mycloudwallet.com'}>
                                <div className="cursor-pointer text-primary hover:font-bold">
                                    {'WAX Cloud Wallet'}
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </Page>
    )
}

export default CreatorView
